import { render, staticRenderFns } from "./clearData.vue?vue&type=template&id=69b8a8d2&scoped=true"
import script from "./clearData.vue?vue&type=script&lang=js"
export * from "./clearData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b8a8d2",
  null
  
)

export default component.exports